export const LOAD_REQUESTED = "PROJECT_CONFIG/LOAD_REQUESTED";
export const LOAD_FAILED = "PROJECT_CONFIG/LOAD_FAILED";
export const LOAD_SUCCEEDED = "PROJECT_CONFIG/LOAD_SUCCEEDED";
export const UPDATE_REQUESTED = "PROJECT_CONFIG/UPDATE_REQUESTED";
export const UPDATE_FAILED = "PROJECT_CONFIG/UPDATE_FAILED";
export const UPDATE_SUCCEEDED = "PROJECT_CONFIG/UPDATE_SUCCEEDED";
export const UPDATE_DEFAULT_REQUESTED = "INSTANCE_DEFAULT/UPDATE_DEFAULT_REQUESTED";
export const UPDATE_DEFAULT_FAILED = "INSTANCE_DEFAULT/UPDATE_DEFAULT_FAILED";
export const UPDATE_DEFAULT_SUCCEEDED = "INSTANCE_DEFAULT/UPDATE_DEFAULT_SUCCEEDED";

export default (
  state = {
    data: [],
    errors: [],
    loading: 0,
    updateDefaultSuccess: false,
    updateSuccess: false,
  },
  { type, data }
) => {
  switch (type) {
  case LOAD_REQUESTED: {
    ++state.loading;
    return state;
  }
  case LOAD_FAILED: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  case LOAD_SUCCEEDED: {
    --state.loading;
    state.data = data;
    return state;
  }
  case UPDATE_REQUESTED: {
    ++state.loading;
    return state;
  }
  case UPDATE_FAILED: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  case UPDATE_SUCCEEDED: {
    --state.loading;
    state.updateSuccess = data;
    return state;
  }
  case UPDATE_DEFAULT_REQUESTED: {
    ++state.loading;
    return state;
  }
  case UPDATE_DEFAULT_FAILED: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  case UPDATE_DEFAULT_SUCCEEDED: {
    --state.loading;
    state.updateDefaultSuccess = data;
    return state;
  }
  default:
    return state;
  }
};

export const loadRequested = (data, resolve, reject) => ({ type: LOAD_REQUESTED, data, resolve, reject });
export const loadFailed = data => ({ type: LOAD_FAILED, data });
export const loadSucceeded = data => ({ type: LOAD_SUCCEEDED, data });

export const updateRequested = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
export const updateFailed = data => ({ type: UPDATE_FAILED, data });
export const updateSucceeded = data => ({ type: UPDATE_SUCCEEDED, data });

export const updateDefaultRequested = (data, resolve, reject) => ({
  type: UPDATE_DEFAULT_REQUESTED,
  data,
  resolve,
  reject,
});
export const updateDefaultFailed = data => ({ type: UPDATE_DEFAULT_FAILED, data });
export const updateDefaultSucceeded = data => ({ type: UPDATE_DEFAULT_SUCCEEDED, data });
